export const ApiContacts = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const save = async (id, payload) => {
    const result = await axios.post(`/api/contacts/${id}`, payload)
    return result.data
  }

  const find = async (id) => {
    const result = await axios.get(`/api/contacts/${id}`)
    return result.data
  }

  const load = async () => {
    const result = await axios.get('/api/contacts')
    return result.data
  }

  return {
    contactsFind: find,
    contactsLoad: load,
    contactsSave: save
  }
}
